// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"708":"component---src-pages-404-js","936":"component---src-pages-index-js"}[chunkId] + "-" + {"708":"857b868457462fcc2deb","936":"88300a9fb29024cd71b8"}[chunkId] + ".js";
};